import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    back: 'Back',
  },
  fr: {
    back: 'Retour',
  },
} as const);

export default locales;
